import { apiDelete, apiGet } from '../client';
import type { CrashEvent, DashboardSummary } from '@/types/api';

/** Counts are role-scoped server-side: owners see their own, admins see everything. */
export function fetchSummary(): Promise<DashboardSummary> {
  return apiGet<DashboardSummary>('/dashboard/summary');
}

/** The only way to read crash events — there is no per-crash detail endpoint. */
export function listCrashes(limit = 50): Promise<CrashEvent[]> {
  return apiGet<CrashEvent[]>('/dashboard/crashes', { query: { limit } });
}

export interface CleanupResult {
  message: string;
  deleted_count: number;
}

/**
 * Administrator only, audit-logged, and bounded by CRASH_RETENTION_DAYS (365).
 * Crash records can be legally significant; this is not a convenience button.
 */
export function clearOldEvents(): Promise<CleanupResult> {
  return apiDelete<CleanupResult>('/dashboard/clear-old-events');
}
